import React, { ComponentProps } from "react";

export default function TimeCircleOutlineIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3795_656225)">
        <path
          d="M8.00008 0.666687C6.54969 0.666687 5.13186 1.09678 3.9259 1.90258C2.71994 2.70837 1.78001 3.85368 1.22497 5.19368C0.669925 6.53367 0.524701 8.00816 0.807659 9.43068C1.09062 10.8532 1.78905 12.1599 2.81464 13.1855C3.84022 14.2111 5.1469 14.9095 6.56942 15.1924C7.99195 15.4754 9.46644 15.3302 10.8064 14.7751C12.1464 14.2201 13.2917 13.2802 14.0975 12.0742C14.9033 10.8682 15.3334 9.45042 15.3334 8.00002C15.3311 6.0558 14.5578 4.19187 13.183 2.8171C11.8082 1.44233 9.9443 0.668981 8.00008 0.666687ZM8.00008 14C6.8134 14 5.65336 13.6481 4.66666 12.9888C3.67997 12.3295 2.91093 11.3925 2.45681 10.2961C2.00268 9.19976 1.88386 7.99336 2.11537 6.82948C2.34688 5.66559 2.91833 4.59649 3.75744 3.75738C4.59656 2.91826 5.66566 2.34682 6.82954 2.11531C7.99343 1.8838 9.19983 2.00262 10.2962 2.45674C11.3925 2.91087 12.3296 3.6799 12.9889 4.6666C13.6482 5.65329 14.0001 6.81333 14.0001 8.00002C13.9981 9.59072 13.3654 11.1157 12.2406 12.2405C11.1158 13.3653 9.59079 13.9981 8.00008 14Z"
          fill="#6C53E8"
        />
        <path
          d="M8.66659 7.72398V3.99998C8.66659 3.82317 8.59635 3.6536 8.47132 3.52858C8.3463 3.40355 8.17673 3.33331 7.99992 3.33331C7.82311 3.33331 7.65354 3.40355 7.52851 3.52858C7.40349 3.6536 7.33325 3.82317 7.33325 3.99998V7.99998C7.33329 8.17678 7.40355 8.34632 7.52859 8.47131L9.52859 10.4713C9.65432 10.5928 9.82272 10.6599 9.99752 10.6584C10.1723 10.6569 10.3395 10.5868 10.4631 10.4632C10.5867 10.3396 10.6568 10.1724 10.6584 9.99758C10.6599 9.82278 10.5927 9.65438 10.4713 9.52865L8.66659 7.72398Z"
          fill="#6C53E8"
        />
      </g>
      <defs>
        <clipPath id="clip0_3795_656225">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
